import React, {memo, useEffect, useState,} from 'react';
import theme from './style';
import {Paper, Grid, Typography} from '@material-ui/core';
import translate from '../../misc/applyTranslation';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {useConfig} from "../../context/configContext";
import APICall, {APIDownload} from '../../misc/APICall';

const ContactsView = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const {userData, access_token} = props;
  const {
    address1,
    address2,
    name,
    name2,
    post_code,
    city,
    country,
    email1,
    email2,
    tel1,
    tel2,
  } = userData;

  const [files, setFiles] = useState([]);

  const fetchCustomerAgreements = () => {
    APICall({
      access_token: access_token,
      url: `file/customer_files?customer_id=${userData.id}`,
      verb: "get"
    })
      .then(res => {
        res ? setFiles(res) : setFiles([]);
      })
  }

  const handleDownloadFile = (file_id) => {
    APIDownload({
      access_token: access_token,
      url: `file/customer_file?file_id=${file_id}&customer_id=${userData.id}`,
      verb: "get",
    })
      .then(({blob, filename}) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = filename || "customer_file";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(err => console.log(err));
  }

  useEffect(() => {
    fetchCustomerAgreements();
    // eslint-disable-next-line
  }, [userData]);

  return (
    <React.Fragment>
      <Paper className={classes.container}>
        <div className='title'>{translate('my-info', 'my_info_panel_title')}</div>
        <Grid container>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'my_info_panel_name_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>{name} {name2}</Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'my_info_panel_address_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>
            <p>{address1 + address2}</p>
            <p>{post_code} {city}</p>
            <p>{country}</p>
          </Grid>
        </Grid>
        <div className='title'>{translate('my-info', 'contacts_panel_title')}</div>
        <Grid container>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'contacts_panel_email1_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>{email1}</Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'contacts_panel_email2_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>{email2}</Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'contacts_panel_mobile1_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>{tel1}</Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}
                className='label'>{translate('my-info', 'contacts_panel_mobile2_label')}</Grid>
          <Grid item xs={12} sm={6} md={8} lg={9} className='text'>{tel2}</Grid>
        </Grid>
        <div style={{maxWidth: 400}}>
          <Typography style={{color: config.color2}}>{translate('my-info', 'panel_change_warning')}</Typography>
        </div>
      </Paper>

      {(files && files.length > 0) &&
        <Paper className={classes.agreementsContainer}>
          <div className='title'>{translate('my-info', 'customer_agreements_title')}</div>
          <div className='subTitle'>{translate('my-info', 'customer_agreements_subtitle')}</div>
          <Grid container style={{marginTop: 20}}>
            <Grid item xs={12}>
              {files.map(item => (
                <ul>
                  <li onClick={() => handleDownloadFile(item.id)}>{item.original_file_name}</li>
                </ul>
              ))}
            </Grid>
          </Grid>
        </Paper>
      }
    </React.Fragment>
  )
}

ContactsView.propTypes = {}
const mapStateToProps = store => ({
  userData: store.login.userData,
  access_token: store.login.access_token,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(ContactsView));